import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { applyBranding } from '@/branding/applyBranding';
import { AppBootstrapGate } from '@/components/common/app-bootstrap-gate';
import { ensureAmplitudeInit } from '@/lib/amplitude';
import '@/lib/i18n';
import { appQueryClient } from '@/lib/query-client';
import { AppBootstrapProvider } from '@/providers/AppBootstrapProvider';
import { AuthProvider } from '@/providers/AuthProvider';
import { IntercomProvider } from '@/providers/IntercomProvider';
import { PostHogProvider } from '@/providers/PostHogProvider';
import '@/styles/globals.css';
import { routeTree } from './routeTree.gen';

const router = createRouter({
    routeTree,
    defaultPreload: 'intent'
});

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}

applyBranding();
ensureAmplitudeInit();

const rootElement = document.getElementById('root')!;

createRoot(rootElement).render(
    <StrictMode>
        <QueryClientProvider client={appQueryClient}>
            <AuthProvider>
                <PostHogProvider>
                    <IntercomProvider>
                        <AppBootstrapProvider>
                            <AppBootstrapGate>
                                <RouterProvider router={router} />
                            </AppBootstrapGate>
                        </AppBootstrapProvider>
                    </IntercomProvider>
                </PostHogProvider>
            </AuthProvider>
        </QueryClientProvider>
    </StrictMode>
);
